module.exports = __webpack_public_path__ + "img/viewfilter-columns.107fbc59.png";